import React   from "react";
import {  Modal, ModalBody } from "reactstrap"

import {
    Table,
} from "reactstrap";

import '../style/style.scss'
export const VerCompraModal = ({
    verCompras,
    onCloseClick,
    compraDetalle
}) => {
   



    return ( 

        <React.Fragment>
        <Modal isOpen={verCompras} toggle={onCloseClick} centered={true} >
         

         <div className="modal-header">
          <h3 className="modal-title mt-2">
          Compra 
        </h3>
           
            <button
              
              type="button"
              className="btn btn-primary button-10-width "
              onClick={() => {
                onCloseClick()
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
       </div>

         <ModalBody>
            
         <Table className="table-bordered table-striped text-center mb-3" responsive>
        <thead>
        <tr>
            {compraDetalle && compraDetalle.adjuntar_cotizacion !== null ? (
                <>
                <th>COTIZACION</th>
                <th>
                    <a href={compraDetalle.adjuntar_cotizacion} target="_blank" rel="noreferrer">
                    <span className="fas fa-file-pdf fa-2x" style={{ cursor: "pointer", color: "#045e94" }}></span>
                    </a>
                </th>
                </>
            ) : null}
                  </tr>
                  <tr>

            {compraDetalle && compraDetalle.prefacturacion !== null ? (
                <>
                <th>PREFACTURA</th>
                <th>
                    <a href={compraDetalle.prefacturacion} target="_blank" rel="noreferrer">
                    <span className="fas fa-file-pdf fa-2x" style={{ cursor: "pointer", color: "#045e94" }}></span>
                    </a>
                </th>
                </>
            ) : null}


            {compraDetalle && compraDetalle.comprobante !== null ? (
                <>
                <th>COMPROBANTE</th>
                <th>
                    <a href={compraDetalle.comprobante} target="_blank" rel="noreferrer">
                    <span className="fas fa-file-pdf fa-2x" style={{ cursor: "pointer", color: "#045e94" }}></span>
                    </a>
                </th>
                </>
            ) : null}
                  </tr>
      
        </thead>
       
        </Table>


         </ModalBody>
         </Modal>
         </React.Fragment>
     );
}
 
export default VerCompraModal;